import { render, staticRenderFns } from "./DesignRirekisho002Preview.vue?vue&type=template&id=51f0a4b2"
import script from "./DesignRirekisho002Preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho002Preview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports